import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ensurePWAMetaTags } from "@/lib/pwaMeta";

// Phase 36 Batch W — re-assert the PWA meta tags before React paints.
// The tags ship in /public/index.html via Batch V, but the Batch W
// smoke test caught a prod build that was missing them (stale deploy).
// This module-level call is idempotent — if the static tags are
// already in place, it's a no-op. If a future CDN HTML rewriter or
// third-party script clobbers the head, this restores them.
ensurePWAMetaTags();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Phase 36 Batch V — Progressive Web App service-worker registration ──
//
// Registering AFTER the React render so the initial paint isn't delayed
// by the SW boot. `load` event ensures we don't compete with hydration
// for the main thread. Failures are silent — the app must keep working
// without a SW (and in dev mode the SW would just cache the unhashed CRA
// dev bundle and confuse hot reload).
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  const isProdHost = window.location.hostname !== "localhost"
    && window.location.hostname !== "127.0.0.1";
  if (isProdHost) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
        // Log instead of swallow — the browser console is the right
        // place to surface SW boot problems; never throw.
        // eslint-disable-next-line no-console
        console.warn("[runidea] sw register failed:", err);
      });
    });
  }
}
